import React from "react";
import { LandingNav } from "../components/LandingNav";
import { scrollToPricing } from "../components/landing/shared";
import { StickyMobileCTA } from "../components/landing/StickyMobileCTA";
import { HeroSection } from "../components/landing/HeroSection";
import { PainIsRealSection } from "../components/landing/PainIsRealSection";
import { VideoSection } from "../components/landing/VideoSection";
import { ApproachSection } from "../components/landing/ApproachSection";
import { DeviceSection } from "../components/landing/DeviceSection";
import { RestoreStrengthSection } from "../components/landing/RestoreStrengthSection";
import { AppSection } from "../components/landing/AppSection";
import { CheckoutSection } from "../components/landing/CheckoutSection";
import { SiteFooter } from "../components/landing/SiteFooter";

export default function Landing() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-[#040814]" data-testid="landing-page">
      <div className="bps-ambient" />
      <LandingNav onCta={scrollToPricing} />
      <StickyMobileCTA />

      <HeroSection />
      <PainIsRealSection />
      <VideoSection />
      <ApproachSection />
      <DeviceSection />
      <RestoreStrengthSection />
      <AppSection />
      <CheckoutSection />
      <SiteFooter />
    </div>
  );
}
